<template>
    <div v-observe-visibility="visibilityChanged">

        <!-- MessageDialog-->
        <inquirySupplierRequestDialog></inquirySupplierRequestDialog>

        <v-layout id="table-container" row ml-4 mr-4 mt-4>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Inquriry Supplier Requests
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0"
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openDialog(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.supplier ? props.item.supplier.name : 'unknown...' }}</td>
                                <td class="text-xs-left">{{ props.item.inquiries_supplier_requests_status.name ? props.item.inquiries_supplier_requests_status.name : 'unknown...' }}</td>
                                <td class="text-xs-left">{{ props.item.created_at ? props.item.created_at : 'unknown...' }}</td>
                                <td class="text-xs-left">{{ props.item.updated_at ? props.item.updated_at : 'unknown...' }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>

        </v-layout>

        <v-layout mt-5 pb-3 mr-3 row justify-end>
            <v-btn mt-5 dark color="secondary" @click.native="">
                Add Supplier Offers
                <v-icon class="white--text" right>arrow_forward</v-icon>
            </v-btn>
        </v-layout>

    </div>

</template>

<script>
import {
  Settings,
  Inquiry,
  InquirySupplierRequests
} from '../../../store/namespace-helper'

import _ from 'lodash'

import inquirySupplierRequestDialog from './InquirySupplierRequestDialog.vue'

export default {
  name: 'InquirySupplierRequests',
  components: {
    inquirySupplierRequestDialog
  },
  data () {
    return {
      whisperChannel: null,
      isVisible: false,
      headers: [
        {text: 'Request-ID', value: 'id'},
        {text: 'Supplier', value: 'supplier.name', sortable: false},
        {text: 'Status', value: 'inquiries_supplier_requests_status_id'},
        {text: 'Created', value: 'created_at'},
        {text: 'Updated', value: 'updated_at'}

      ],
      pagination: {},
      search: '',
      total: 0,
      onDismissed: false,
      rowsPageItems: [50, 10, 25, 100, 250]
    }
  },
  beforeDestroy () {
    console.log('leaving ' + 'messages-chan.' + this.getMessageChanUUID)
    this.$echo.leave('messages-chan.' + this.getMessageChanUUID)
  },
  mounted () {
    /*        this.whisperChannel = this.$echo.private('chat-chan.1').listenForWhisper('typing', (e) => {
          console.log(e.name)
        }) */
    this.$store.dispatch(InquirySupplierRequests.actions.setMessageChanUUID, this.$uuid.v4())
    console.log('listening ' + 'messages-chan.' + this.getMessageChanUUID)
    this.$echo.private('messages-chan.' + this.getMessageChanUUID).listen('MessageSent', (payload) => {
      console.log('message sent event: ' + JSON.stringify(payload))
      this.loadItems()
    })
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')

          this.loadItems()
        } else {
          this.activeTab = 0
        }
      }
    },
    loadItems: function () {
      try {
        const {sortBy, descending, page, rowsPerPage} = this.pagination
        const query = {
          id: this.getSelectedInquiry.id,
          sortBy: sortBy || 'id',
          descending: descending ? 'desc' : 'asc',
          page: page || 1,
          limit: rowsPerPage !== -1 ? rowsPerPage : 0,
          search: this.search ? this.search : ''
        }
        this.$store.dispatch(InquirySupplierRequests.actions.loadInquirySupplierRequests, query)
      } catch (e) {
        console.error(e)
      }
    },
    loadSuppliers (manufacturersId) {
      console.log('loading all suppliers for manufacturers_id: ' + manufacturersId)
      this.$store.dispatch(Settings.actions.loadSuppliersByManufacturers, manufacturersId)
    },
    openDialog (val) {
      if (val !== null) {
        let item = this.getItems.find(x => x.id === val)
        this.$store.dispatch(InquirySupplierRequests.actions.setSelectedInquirySupplierRequest, item)
      }

      this.$store.dispatch(InquirySupplierRequests.actions.openCloseInquirySupplierRequestMessageDialog)
    },
    throttledLoadItems: _.debounce(function () {
      this.loadItems()
    }, 450)

  },
  computed: {
    getItems () {
      this.total = this.$store.getters[InquirySupplierRequests.getters.inquirySupplierRequests].total
      return this.$store.getters[InquirySupplierRequests.getters.inquirySupplierRequests].data
    },
    getSelectedRequest () {
      return this.$store.getters[InquirySupplierRequests.getters.getSelectedInquirySupplierRequest]
    },
    getSelectedInquiry () {
      return this.$store.getters[Inquiry.getters.getSelectedInquiry]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    dialogState () {
      return this.$store.getters[InquirySupplierRequests.getters.getOpenInquirySupplierRequestMessageDialogState]
    },
    getMessageChanUUID () {
      return this.$store.getters[InquirySupplierRequests.getters.getMessageChanUUID]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadItems()
      },
      deep: true
    },
    search: {
      handler () {
        /*            this.whisperChannel.whisper('typing', {
              name: 'hatto'
            }) */
        this.throttledLoadItems()
      },
      deep: true
    }
  }

}
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Distribution/SupplierRequests/InquirySupplierRequests.vue